/* Top Shelf — scroll reveal for .ts-reveal elements.
   Progressive enhancement: if JS or IntersectionObserver is unavailable,
   a <noscript> rule in theme.liquid makes .ts-reveal fully visible. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function revealAll() {
    document.querySelectorAll('.ts-reveal').forEach(function (el) { el.classList.add('ts-in'); });
  }
  if (reduce || !('IntersectionObserver' in window)) {
    if (document.readyState !== 'loading') revealAll();
    else document.addEventListener('DOMContentLoaded', revealAll, { once: true });
    return;
  }
  function init() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ts-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.ts-reveal:not(.ts-in)').forEach(function (el) { io.observe(el); });
    // Safety net: never leave content hidden.
    setTimeout(revealAll, 3000);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
